import React from 'react';
import { Navigate, useLocation } from 'react-router';

import { TCustomRouteObject } from '@/shared/types/router.types';

// Console Latency moved under the SRE Hub; links shared before the move keep
// their period, region and other filters.
const ConsoleLatencyMovedRedirect: React.FC = () => {
  const { search } = useLocation();

  return <Navigate to={`/sre-hub/console-latency${search}`} replace />;
};

export const legacyConsoleLatencyRoutes: TCustomRouteObject = {
  path: 'console-latency',
  Component: ConsoleLatencyMovedRedirect,
};
